import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dialog, {
      width: "500px",
      title: _ctx.title,
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
      "close-on-click-modal": false,
      onClose: _ctx.handleCloseDialog
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, { onClick: _ctx.handleCloseDialog }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitDialog
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          "label-width": "120px",
          ref: "ruleForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: '完整车牌号：',
              prop: "carNo"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.carNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.carNo = $event)),
                  placeholder: '请输入'
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onClose"])
  ]))
}